<template>
  <div>
    <!-- 指定分享 -->
    <el-dialog class="main_dialog" title="共享素材" :visible.sync="dialogVisible" width="600px">
      <el-alert
        title="分享后不可撤回，将加入到对方的共享素材文件夹中"
        type="warning"
        :closable="false"
        style="margin-bottom: 24px"
      ></el-alert>
      <!-- 表单 -->
      <el-form ref="ruleForm">
        <el-form-item label="指定分享">
          <el-select
            style="width: 300px"
            v-model="account"
            placeholder="请选择指定分享"
            multiple
            filterable
            allow-create
            collapse-tags
            default-first-option
            @change="changeAccount"
          >
            <el-checkbox
              v-model="checked"
              @change="selectAll"
              style="margin-left: 20px"
            >
              全选
            </el-checkbox>
            <el-option
              v-for="item in options"
              :key="item.mobile"
              :label="item.nickname"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div style="text-align: right;">
        <el-button class="dialog_cancel" size="small" @click="cancel">取 消</el-button>
        <el-button class="dialog_confirm" size="small" @click="submit" :loading="loading"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { subGetList  } from "@/api/subaccount";
import { folderFileShare } from "@/api/material";
export default {
  name: "SpecifyShare",
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      subAccount: "",
      loading: false,
      checked: false, //全选
      dialogVisible: false,
      account: [],
      options: [],
    };
  },
  methods: {
    selectAll() {
      this.account = [];
      if (this.checked) {
        this.options.map((item) => {
          this.account.push(item.id);
        });
      }
    },
    // 获取子账号列表
    getSubAccount() {
      subGetList().then((res) => {
        this.options = res.data;
      });
    },
    changeAccount(ids) {
      if (ids.length === this.options.length) {
        this.checked = true;
      } else {
        this.checked = false;
      }
    },
    submit() {
      this.loading = true;
      let folder_ids = []
      let file_ids = []
      this.list.forEach((item) => {
        if(item.type == 1) {
          folder_ids.push(item.id)
        }else {
          file_ids.push(item.id)
        }
      });
      folderFileShare({target_user_ids: this.account, folder_ids, file_ids}).then((res) => {
        this.dialogVisible = false;
        this.loading = false;
        this.$message.success(res.data);
      });
    },
    //   取消
    cancel() {
      this.account = [];
      this.dialogVisible = false;
    },
  },
  watch: {
    dialogVisible(newVal) {
      if (newVal) {
        this.account = [];
        this.checked = false;
        this.getSubAccount();
      }
    },
  },
};
</script>

<style lang="scss" scoped>

</style>